import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function BillingCancel() {
  return (
    <div className="max-w-lg mx-auto mt-10 brut-card p-8 text-center space-y-4" data-testid="billing-cancel-page">
      <XCircle className="w-14 h-14 mx-auto text-amber-500" />
      <h1 className="font-heading text-2xl font-black">Checkout cancelled</h1>
      <p className="text-sm text-zinc-600">No charge was made. You can pick a plan again anytime.</p>
      <Link to="/organizations" className="brut-btn px-4 py-2 text-sm inline-block" data-testid="billing-cancel-back">BACK TO ORGANIZATIONS</Link>
    </div>
  );
}
